import { Component } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router"

import { FabricantesService } from '@app/_services/fabricantes.service';

import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService, UsuariosService } from '../_services';

@Component({
  selector: 'app-fabricantes',
  templateUrl: 'fabricantes.component.html'
})

export class FabricantesComponent {

  public seleccionados: number[] = [];
  private translate: TranslateService;
  public fabricantes: [];
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;
  closeResult = '';
  navigationSubscription;
  user = this.userService.userValue;

  constructor(private fabricantesService: FabricantesService,
    translate: TranslateService,
    private menuService: MenuService, public router: Router,
    private translateService: TranslateService,
    private userService: UsuariosService,
    private modalService: NgbModal) {

    this.translate = translate;
    this.menuService.titulo = this.translate.instant('fabricantes').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/fabricantes') {
          this.menuService.titulo = this.translateService.instant('fabricantes');
          this.fabricantesService.GetAll().subscribe((result) => {
            this.fabricantes = result.data;
          }
          );
        } else {
         
        }
      }
    });
  }

  ngOnInit() {
    this.fabricantesService.GetAll().subscribe((result) => {
      this.fabricantes = result.data;
      }
    );
  }

  onClickNuevo() {
    this.router.navigate(['fabricantes/crear/']);
  }

  onClickEditar() {
    if (this.seleccionados[0] > 0) {
      this.router.navigate(['fabricantes/editar/', this.seleccionados[0]]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['fabricantes/editar/', this.seleccionados[0]]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading, contentNotErased) {
   
    this.fabricantesService.delete({ ids: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.fabricantesService.GetAll().subscribe((result) => {
            this.fabricantes = result.data;
          }
          );
        }
        if (data.undeletedElements != "") {
          
          this.modalService.open(contentNotErased, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }
}
